module.exports = __webpack_public_path__ + "static/flags/DO-1e66d4dbdc581b3fcd84a2938c6b674a.gif";